export const platePatterns: Record<string, RegExp> = {
  // AT: district (1-3 L) + 1-5 digits + 1-2 L  e.g. W12345A, GDAB123
  AT: /^[A-Z]{1,3}\d{1,5}[A-Z]{1,2}$/,
  // BE: digit + 3 L + 3 digits  e.g. 1ABC234
  BE: /^[1-9][A-Z]{3}\d{3}$/,
  // BG: 1-2 L + 4 digits + 2 L  e.g. CB1234AB
  BG: /^[A-Z]{1,2}\d{4}[A-Z]{2}$/,
  // CH: canton (1-2 L) + 1-6 digits  e.g. ZH123456
  CH: /^[A-Z]{1,2}\d{1,6}$/,
  // CZ: new format digit+L+digit+4digits or regional 1A+4-5  e.g. 1A23456
  CZ: /^[A-Z0-9]{1}[A-Z]{1}[A-Z0-9]{1}\d{4}$|^[A-Z]{1,2}\d{4,5}[A-Z]{0,2}$/,
  // DE: district (1-3 L) + 1-2 L + 1-4 digits + optional E/H  e.g. ABCD1234
  DE: /^[A-Z]{1,3}[A-Z]{1,2}\d{1,4}[EH]?$/,
  // DK: 2 L + 5 digits  e.g. AB12345
  DK: /^[A-Z]{2}\d{5}$/,
  // ES: new 4 digits + 3 L  or  old province+digits+L  e.g. 1234ABC / M1234AB
  ES: /^\d{4}[A-Z]{3}$|^[A-Z]{1,2}\d{4}[A-Z]{1,2}$/,
  // FR: new 2L+3digits+2L  e.g. AB123CD
  FR: /^[A-Z]{2}\d{3}[A-Z]{2}$/,
  // GB: 2L+2digits+3L  e.g. AB12CDE
  GB: /^[A-Z]{2}\d{2}[A-Z]{3}$/,
  // HU: 3L+3digits (new) or 2L+2digits+2L (old)  e.g. ABC123 / AB12CD
  HU: /^[A-Z]{3}\d{3}$|^[A-Z]{2}\d{2}[A-Z]{2}$/,
  // IT: 2L+3digits+2L  e.g. AB123CD
  IT: /^[A-Z]{2}\d{3}[A-Z]{2}$/,
  // NL: various sidecodes 2+2+2 alphanumeric blocks  e.g. AB12CD
  NL: /^[A-Z0-9]{2}[A-Z0-9]{2,3}[A-Z0-9]{2,3}$/,
  // PL: 2-3 L (district) + 5 alphanum  e.g. WA12345
  PL: /^[A-Z]{2,3}[A-Z0-9]{5}$/,
  // RO: 1-2 L + 2-3 digits + 2-3 L  e.g. B123ABC / CJ12AB
  RO: /^[A-Z]{1,2}\d{2,3}[A-Z]{2,3}$/,
  // SE: 3L+3digits  e.g. ABC123
  SE: /^[A-Z]{3}\d{3}$/,
  // SI: 2L region + 2L + 3 digits  e.g. MBAB123
  SI: /^[A-Z]{2}[A-Z]{2}\d{3}$/,
  // SK: 2L region + 3digits + 2L  e.g. BA001AB
  SK: /^[A-Z]{2}\d{3}[A-Z]{2}$/,
  // UA: 2L + 4digits + 2L  e.g. AA1234BB
  UA: /^[A-Z]{2}\d{4}[A-Z]{2}$/,
  // US: 2-8 alphanumeric (varies by state)
  US: /^[A-Z0-9]{2,8}$/,
};

export const plateDashAllowed = new Set(['BE', 'FR', 'HU', 'NL', 'SI']);

export const plateExamples: Record<string, string> = {
  AT: 'W12345A',
  BE: '1ABC234',
  BG: 'CB1234AB',
  CH: 'ZH123456',
  CZ: '1AB2345',
  DE: 'BAB1234',
  DK: 'AB12345',
  ES: '1234ABC',
  FR: 'AB123CD',
  GB: 'AB12CDE',
  HU: 'ABC123',
  IT: 'AB123CD',
  NL: 'AB123C',
  PL: 'WA12345',
  RO: 'B123ABC',
  SE: 'ABC123',
  SI: 'MBAB123',
  SK: 'BA001AB',
  UA: 'AA1234BB',
  US: 'ABC1234',
};
